// extracted by mini-css-extract-plugin
export var checkbox = "styles-module--checkbox--m6Usm";
export var invalid = "styles-module--invalid--EgHf4";
export var readOnly = "styles-module--readOnly--5stI4";
export var disabled = "styles-module--disabled--634F-";